/**
 * Sentry init — must be imported BEFORE anything else in index.js so
 * its global handlers (window.onerror, onunhandledrejection) are in
 * place before React boots.
 *
 * No-op when REACT_APP_SENTRY_DSN is missing (keeps local dev clean
 * even when devs don't have the key).
 */
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  const environment = process.env.REACT_APP_SENTRY_ENV || 'production';

  Sentry.init({
    dsn,
    environment,
    // Browser tracing: instruments page loads + outgoing fetch/XHR.
    // Propagates the `sentry-trace` + `baggage` headers to our own
    // API so frontend + backend errors link up in one trace.
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Full sampling in preview, lower in production to stay within the
    // free tier's monthly quota.
    tracesSampleRate: environment === 'production' ? 0.2 : 1.0,
    tracePropagationTargets: [
      /^\/api/,
      /budget-forecast-27\.preview\.emergentagent\.com\/api/,
      /forgeledger\.net\/api/,
    ],
    // Strip query strings + form values that may contain secrets before
    // any event leaves the browser.
    beforeSend(event) {
      try {
        const req = event.request || {};
        if (req.query_string && typeof req.query_string === 'string') {
          req.query_string = req.query_string.replace(/(password|token|secret|key)=[^&]*/gi, '$1=[REDACTED]');
        }
        if (req.data && typeof req.data === 'object') {
          for (const k of Object.keys(req.data)) {
            if (/password|token|secret|api[_-]?key/i.test(k)) req.data[k] = '[REDACTED]';
          }
        }
        event.request = req;
      } catch (err) { console.warn('Sentry scrub failed; sending raw:', err); }
      return event;
    },
  });
}

export default Sentry;
